import { create } from 'zustand';
import { toast } from 'react-toastify';
import { IUserData } from '../types';
import { appAxiosInstance } from '../../../api';

interface IUserStore {
  getCurrentUserData: () => void;
  userData: IUserData | null;
}

export const useUserStore = create<IUserStore>((set) => ({
  getCurrentUserData: async () => {
    try {
      const userDataResponse = await appAxiosInstance.get<IUserData>('/mobile/users/current');
      const userData = userDataResponse.data;

      if (userData) {
        set((state) => ({
          ...state,
          userData
        }));
      }

    } catch (error) {
      toast.error('Произошла ошибка');
    }
  },
  userData: null,
}));
